import {Component, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

/**
 * @title Dialog for global http service errors
 */


@Component({
  selector: 'general-dialog',
  templateUrl: 'general-dialog.html',
})
export class GeneralDialog {

  constructor(
    public dialogRef: MatDialogRef<GeneralDialog>,
    @Inject(MAT_DIALOG_DATA) public data: {header:string,message:string}) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}


// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Dialogs/GeneralDialog/general-dialog.ts